import { cn } from '@shadcn/lib/utils';
import { cva } from 'class-variance-authority';
import React from 'react';

type AllowedTags = 'p' | 'li';

const psyomicsCustomOverrides: Record<AllowedTags, string> = {
  p: 'tracking-normal',
  li: '',
};

const tagVariants: Record<AllowedTags, string> = {
  p: psyomicsCustomOverrides.p,
  li: psyomicsCustomOverrides.li,
};

const sizeVariants = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
};

const weightVariants = {
  normal: 'font-normal',
  semibold: 'font-semibold',
  bold: 'font-bold',
};

const textVariants = cva('text-foreground break-words', {
  variants: {
    tag: tagVariants,
    size: sizeVariants,
    weight: weightVariants,
  },
  compoundVariants: [],
  defaultVariants: {
    size: 'md',
    weight: 'normal',
  },
});

type TextSize = keyof typeof sizeVariants;
type TextWeight = keyof typeof weightVariants;

const Text = <T extends React.ElementType & AllowedTags>({
  tag: Tag = 'p',
  className,
  size = 'md',
  weight = 'normal',
  ...props
}: {
  readonly tag?: T | 'p';
  readonly className?: string;
  readonly size?: TextSize;
  readonly weight?: TextWeight;
} & React.ComponentPropsWithoutRef<T>) => (
  <Tag className={cn(textVariants({ tag: Tag, size, weight }), className)} {...props} />
);

export { Text, type TextSize, type TextWeight };
